/* eslint-disable camelcase */
import React from 'react';
import Card from 'components/fullWidthCard';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import Modal, {modalSizes} from 'components/layout/modal';
import hopscotch from 'hopscotch';
import {dealerAdminTourFormat} from 'helpers/constants';
import {ALEXMonitor_Status} from 'lib/alexmonitor';
import {XFCAbout} from 'lib/xfConnect';
import ToolTip, {tooltipPositions} from 'ui/components/ToolTip';
import TC from 'services/testConnect2p0';
import moment from 'moment';
import {
CURRENT_ALEXPROMONITOR_VERSION,
CURRENT_TESTCONNECT_VERSION,
CURRENT_SMARTLABCLIENT_VERSION,
CURRENT_SMARTLABSERVICE_VERSION,
CURRENT_XFCSERVICE_VERSION,
CURRENT_XFCDEVICE_VERSION,
manualScanner
} from 'ui/helpers/constants';
import {compare_versions} from 'util/version';

const LSKEY_DEVICES = 'DEVICE_STATUSES';
const ROWTYPES = {
  DEFAULT: 0,
  SERVICE: 1,
  DEVICE: 2,
};

class DeviceTools extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {
    smartLabPackage: false,
    isXFCPackage: false,
    isSmartLab1Connected: false,
    loadStateReturned: false,
    downTermsVisible: false,
    ALEXMonitorStatuses: {
      'tools.devices.alexmonitor.client': {status: null, version: null, current: null, rowtype: ROWTYPES.DEFAULT},
      'tools.devices.alexmonitor.service': {status: null, version: null, current: null, rowtype: ROWTYPES.SERVICE},
    },
    SmartLabStatuses: {
      'tools.devices.smartlab.client': {status: null, version: null, current: null, rowtype: ROWTYPES.DEFAULT},
      'tools.devices.smartlab.service': {status: null, version: null, current: null, rowtype: ROWTYPES.SERVICE},
      'tools.devices.smartlab1.device': {status: null, version: null, current: null, rowtype: ROWTYPES.DEVICE},
      'tools.devices.smartlab2.device': {status: null, version: null, current: null, rowtype: ROWTYPES.DEVICE},
    },
    XFCStatuses: {
      'tools.devices.xfc.service': {status: null, version: null, current: null, rowtype: ROWTYPES.SERVICE},
      'tools.devices.xfc.device': {status: null, version: null, current: null, rowtype: ROWTYPES.DEVICE},
    },
  };

  componentWillMount() {
    // let lastDeviceStatuses = localStorage.getItem(LSKEY_DEVICES);
    // if (lastDeviceStatuses != null){
    //   this.setState(JSON.parse(lastDeviceStatuses));
    // }

    this.loadState();
  }

  componentDidMount() {
    if (hopscotch.getState() === 'dealerAdmin:17') {
      hopscotch.startTour(dealerAdminTourFormat(this.props.intl.formatMessage), 17);
    }
  };

  componentWillUnmount() {
    if (hopscotch.isActive && window.location.hash !== '#support' && window.location.hash !== '#settings/water-analysis') {
      hopscotch.endTour();
    }
  };

  loadState = () => {
    ALEXMonitor_Status()
    .then((status) => {
      return new Promise((resolve, reject) => {
        if (status != null) {
          // Get AccuFlex™ Connect info
          XFCAbout()
            .then((xfcStatus) => {
              status.XFCServiceVersion = xfcStatus.details ? xfcStatus.details.softwareVersion : null;
              status.isXFCDeviceConnected = xfcStatus.deviceConnected || false;
              // Pass in device firmware information only if device is connected
              if (status.isXFCDeviceConnected) {
                status.XFCDeviceVersion = xfcStatus.details ? xfcStatus.details.deviceFirmware : null;
              }
            })
            .catch(err => {
              console.error(err);
            })
            .finally(() => resolve(status));
        }else{
          /// Fall back to test connect results
          TC.getStatus()
            .then((tc_status) => {
              const results = {
                ALEXProMonitorServiceVersion: null,
                SmartLabDeviceName: tc_status.scanners.length > 1 ? tc_status.scanners[0] : null,
                SmartLabServiceVersion: tc_status.sls_version,
                SmartLabClientVersion: tc_status.sls_client_version,
                SmartLabFirmwareVersion: tc_status.sls_current_firmware,
                SmartLabAvailableFirmwareVersion: tc_status.sls_available_firmware,
                TestConnectVersion: tc_status.tc_version,
                XFCServiceVersion: tc_status.xfc ? tc_status.xfc.version : null,
                XFCDeviceVersion: tc_status.xfc ? tc_status.xfc.deviceVersion : null,
                isXFCDeviceConnected: tc_status.xfc ? tc_status.xfc.isDeviceConnected : null,
              };

              // Get Xpress Connect Info (fallback)
              XFCAbout()
                .then((xfcStatus) => {
                  results.XFCServiceVersion = xfcStatus.details ? xfcStatus.details.softwareVersion : null;
                  results.isXFCDeviceConnected = xfcStatus.deviceConnected || false;
                  if (results.isXFCDeviceConnected) {
                    results.XFCDeviceVersion = xfcStatus.details ? xfcStatus.details.deviceFirmware : null;
                  }
                })
                .catch(err => {
                  console.error(err);
                })
                .finally(() => resolve(results));
            });
        }
      });
    })
    .then((status) => {
      let unpackVersion = (reportedVersion, currentVersion) => {
        if (reportedVersion == null) {return null;}
        return compare_versions(reportedVersion, currentVersion) >= 0;
      };

      let isSmartLabClientCurrent = unpackVersion(status.SmartLabClientVersion, CURRENT_SMARTLABCLIENT_VERSION);
      let isSmartLabServiceCurrent = unpackVersion(status.SmartLabServiceVersion, CURRENT_SMARTLABSERVICE_VERSION);
      let isTestConnectCurrent = unpackVersion(status.TestConnectVersion, CURRENT_TESTCONNECT_VERSION);
      let isALEXProMonitorCurrent = unpackVersion(status.ALEXProMonitorServiceVersion, CURRENT_ALEXPROMONITOR_VERSION);
      let isXFCServiceCurrent = unpackVersion(status.XFCServiceVersion, CURRENT_XFCSERVICE_VERSION);
      let isXFCDeviceCurrent = unpackVersion(status.XFCDeviceVersion, CURRENT_XFCDEVICE_VERSION);

      let TestConnectStatus = status.TestConnectVersion != null;

      // Smart Lab Device info
      let SL1Connected = false;
      let SL2Connected = false;

      let SL1Version = null;
      let SL2Version = null;

      let SL1Current = null;
      let SL2Current = null;

      if (status.SmartLabDeviceName != null && status.SmartLabDeviceName !== manualScanner) {
        if (status.SmartLabDeviceName.indexOf('2') < 0) {
          //Smart Lab 1 connected.
          SL1Connected = true;

          SL1Version = status.SmartLabFirmwareVersion;
          SL1Current = compare_versions(status.SmartLabFirmwareVersion, status.SmartLabAvailableFirmwareVersion) >= 0;
        }else{
          //Smart Lab 2 connected.
          SL2Connected = true;

          SL2Version = status.SmartLabFirmwareVersion;
          SL2Current = compare_versions(status.SmartLabFirmwareVersion, status.SmartLabAvailableFirmwareVersion) >= 0;
        }
      }

      let newStatuses = {
        isSmartLab1Connected: SL1Connected,
        ALEXMonitorStatuses: {
          'tools.devices.alexmonitor.client': {
            status: status.ALEXProMonitorServiceVersion != null,
            version: status.ALEXProMonitorServiceVersion,
            current: isALEXProMonitorCurrent,
            rowtype: ROWTYPES.DEFAULT,
          },
          'tools.devices.alexmonitor.service': {
            status: status.ALEXProMonitorServiceVersion != null,
            version: status.ALEXProMonitorServiceVersion,
            current: isALEXProMonitorCurrent,
            rowtype: ROWTYPES.SERVICE,
          },
        },
        SmartLabStatuses: {
          'tools.devices.smartlab.client': {
            status: status.SmartLabClientVersion != null,
            version: status.SmartLabClientVersion,
            current: isSmartLabClientCurrent,
            rowtype: ROWTYPES.DEFAULT,
          },
          'tools.devices.smartlab.service': {
            status: status.SmartLabServiceVersion != null,
            version: status.SmartLabServiceVersion,
            current: isSmartLabServiceCurrent,
            rowtype: ROWTYPES.SERVICE,
          },
          'tools.devices.smartlab1.device': {
            status: SL1Connected,
            version: SL1Version,
            current: SL1Current,
            rowtype: ROWTYPES.DEVICE,
          },
          'tools.devices.smartlab2.device': {
            status: SL2Connected,
            version: SL2Version,
            current: SL2Current,
            rowtype: ROWTYPES.DEVICE,
          },
        },
        XFCStatuses: {
          'tools.devices.xfc.service': {
            status: status.XFCServiceVersion != null,
            version: status.XFCServiceVersion,
            current: isXFCServiceCurrent,
            rowtype: ROWTYPES.SERVICE,
          },
          'tools.devices.xfc.device': {
            status: status.isXFCDeviceConnected,
            version: status.XFCDeviceVersion,
            current: isXFCDeviceCurrent,
            rowtype: ROWTYPES.DEVICE,
          },
        },
      };

      localStorage.setItem(LSKEY_DEVICES, JSON.stringify(newStatuses));

      this.setState(newStatuses);
    })
    .finally(() => {
      this.setState({
        loadStateReturned: true,
      });
    });
  };

  closeDownloadModal = () => {
    this.setState({downTermsVisible: false});
  };

  download = () => {
    if (this.state.smartLabPackage) {
      location.href = '/Content/ALEXProSmartLab1.5.zip';
    } else if (this.state.isXFCPackage) {
      location.href = '/Content/ALEXXFConnect1.1.8.3.zip';
    } else {
      location.href = '/Content/ALEXProAccuScan2.0.zip';
    }
    this.closeDownloadModal();
  };

  openDownloadModal = (smartLabPackage, isXFCPackage) => {
    this.setState(
      {
        smartLabPackage: smartLabPackage,
        isXFCPackage: isXFCPackage,
        downTermsVisible: true,
      });
  };

  getStatusCopy = (status, rowtype) => {
    if (status === null || rowtype === null) {return '-';}

    switch(rowtype) {
      case ROWTYPES.SERVICE:
        let runningCopy = this.props.intl.formatMessage({id: 'general.running'});
        let notRunningCopy = this.props.intl.formatMessage({id: 'general.not.running'});

        return status ? runningCopy : notRunningCopy;
      case ROWTYPES.DEVICE:
        let connectedCopy = this.props.intl.formatMessage({id: 'general.connected'});
        let notConnectedCopy = this.props.intl.formatMessage({id: 'general.not.connected'});

        return status ? connectedCopy : notConnectedCopy;
      default: // ROWTYPES.DEFAULT
        let installedCopy = this.props.intl.formatMessage({id: 'general.installed'});
        let unavailableCopy = '-';

        return status ? installedCopy : unavailableCopy;
    }
  };

  getCurrentCopy = (current) => {
    if (current === null) {return '-';}

    let yesCopy = this.props.intl.formatMessage({id: 'general.yes'});
    let noCopy = this.props.intl.formatMessage({id: 'general.no'});

    return current ? yesCopy : noCopy;
  };

  renderStatusTable = (title, statuses, showDownloadButton, smartLabPackage = false, isXFCPackage = false) => {
    let rows = [];

    // Header row.
    rows.push(<tr key="-1">
      <th><h3>{title}</h3></th>
      <th><FormattedMessage id="general.status"/></th>
      <th><FormattedMessage id="general.version"/></th>
      <th><FormattedMessage id="general.current"/></th>
      <th></th>
    </tr>);

    // Application/Service/Device rows.
    let keys = Object.keys(statuses);

    for(let i = 0; i < keys.length; i++) {
      rows.push(<tr key={i}>
        <td className="tdname"><FormattedMessage id={keys[i]} /></td>
        <td className="tdstatus">{this.getStatusCopy(statuses[keys[i]].status, statuses[keys[i]].rowtype)}</td>
        <td className="tdversion">{statuses[keys[i]].version != null ? statuses[keys[i]].version : '-' }</td>
        <td className="tdcurrent">{this.getCurrentCopy(statuses[keys[i]].current)}</td>
        {showDownloadButton && i === 0 && <td rowSpan="0"  className="tddownload">
          <button
            className='btn btn-primary pull-right download-package'
            onClick={(e) => {
              e.stopPropagation();
              this.openDownloadModal(smartLabPackage, isXFCPackage)
            }}
          >
            <FormattedMessage id="tools.download.package"/>
          </button>
        </td>}
        {!showDownloadButton && <td  className="tddownload"></td>}
      </tr>);
    }

    return <table>
      <tbody>
        {rows}
      </tbody>
    </table>;

    return {rows};
  };

  renderSmartLabStatusTable = () => {
    return this.renderStatusTable('Smart Lab™ 1 & 2', this.state.SmartLabStatuses, true, true);
  }

  renderXFCStatusTable = () => {
    return this.renderStatusTable('AccuFlex™', this.state.XFCStatuses, true, false, true);
  }

  renderALEXMonitorStatusTable = () => {
    let title = <React.Fragment>
      <FormattedMessage id="tools.devices.alexmonitor" />
      <ToolTip title={this.props.intl.formatMessage({id: 'tools.devices.alexmonitor.tooltip'})}
                   position={tooltipPositions.rightTop} iconOnly/>
    </React.Fragment>;

    return this.renderStatusTable(title, this.state.ALEXMonitorStatuses, false);
  }

  getDownloadModal = () => {

    if (this.state.downTermsVisible) {
      return <Modal onClose={this.closeDownloadModal} size={modalSizes.small}>
        <div>
          <p style={{marginBottom: 15}}><FormattedMessage id="tools.connect.description" values={{
            terms: <a href="#terms-of-service"
                      target="_blank"><FormattedMessage id="general.terms.use"/></a>,
            site: <a href="alex.mybioguard.com"
                      target="_blank">alex.mybioguard.com</a>,
          }}/>
          </p>
          <button className='btn btn-default'
                  onClick={this.closeDownloadModal}><FormattedMessage id="general.cancel"/></button>
          <button className='btn btn-primary pull-right'
                  onClick={this.download}><FormattedMessage id="tools.accept.download"/></button>
        </div>
      </Modal>;
    }

    return null;
  }

  render() {
    let downloadModal = this.getDownloadModal();

    return <React.Fragment>
      <div className='full-width-card devices'>
        <div className='row'>
          {this.renderALEXMonitorStatusTable()}
        </div>
      </div>
      <div className='full-width-card devices'>
        <div className='row'>
          {this.renderSmartLabStatusTable()}
          <hr />
          <table>
            <tbody>
              <tr>
                <td className="tdname"><FormattedMessage id="tools.devices.smartlab1.calibration"/></td>
                <td className="tdinstructions">
                  <a href="#tools/calibration"><FormattedMessage id="general.view.instructions"/></a>
                </td>
                <td className="tdcalibration">
                  {this.state.isSmartLab1Connected && <a className='btn btn-primary pull-right' href='#tools/calibration'>
                    <FormattedMessage id="tools.start.calibration"/>
                  </a>}
                </td>
              </tr>
            </tbody>
          </table>
          <hr />
          <table>
            <tbody>
              <tr>
                <td className="tdname"><FormattedMessage id="tools.devices.smartlab2.calibration"/></td>
                <td className="tdinstructions">
                  <a href="#encyclopedia/23c3f2e5-000d-4369-ae3b-7410e7ad872c"><FormattedMessage id="general.view.instructions"/></a>
                </td>
                <td className="tdcalibration"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className='full-width-card devices'>
        <div className='row'>
          {this.renderXFCStatusTable()}
        </div>
      </div>
      {downloadModal}
    </React.Fragment>;
  }
}

export default injectIntl(DeviceTools);
